import { useContext } from "react";
import { ImagineLogo } from "../utils/icons";
import styles from "./header.module.scss";
import CurrentContext from "../utils/CurrentContext";

export function Header() {
  const { aspectRatio } = useContext(CurrentContext);
  const headerPadding = (0.5 * aspectRatio).toString() + "% "+(1 * aspectRatio).toString() + "%";

  return (
    <div
      className={styles.header}
      style={{
        padding: headerPadding,
      }}
    >
      <a href="https://imagine.io" target="_blank" rel="noopener noreferrer"> 
        <ImagineLogo scale={aspectRatio >= 1? 120 : 320 * aspectRatio} />
      </a>
    </div>
  );
}
